import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {IndividualAccidentsRequest, IndividualAccidentsScenario} from '../../../model/IndividualAccidents';
import {AppSettingsService} from '../../../services/app-settings.service';
import {Label, PaymentInfo, Response, StaticMethods} from '../../../model/GeneralModels';
import {IndividualAccidentsService} from '../../../services/individual-accidents.service';
import {Router} from '@angular/router';
import {FormBuilder, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {GeneralService} from '../../../services/general.service';

@Component({
  selector: 'app-request-details',
  templateUrl: './request-details.component.html',
  styleUrls: [
    '../../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css',
  ]
})
export class RequestDetailsComponent implements OnInit {
  requestInfo: IndividualAccidentsRequest[] = [];
  paymentMode = false;
  paymentInfo: PaymentInfo = new PaymentInfo();
  formGroup = this.fb.group({
    discountCode: ['', Validators.required]
  });
  file = new Label('', '');
  pageStatus: string;
  buttonLabel = '';
  requestID: number;
  icon = 'ico-person-outline';
  translation: any = {};

  constructor(private service: IndividualAccidentsService,
              private router: Router,
              public settings: AppSettingsService,
              private cdRef: ChangeDetectorRef,
              private fb: FormBuilder,
              private dialog: MatDialog,
              private generalServices: GeneralService) {
  }

  ngOnInit() {
    if (StaticMethods.checkState(this.router, ['requestID'], '/INDIVIDUAL_ACCIDENTS/requests')) {
      this.requestID = history.state.requestID;
      this.getDetails(this.requestID, () => {
        this.cdRef.detectChanges();
      });
    }
  }


  takeAction() {
    switch (this.requestInfo[0].currentStep) {
      case IndividualAccidentsScenario.paid:
        this.showPaymentPanel();
        break;
      case IndividualAccidentsScenario.insuranceReleased:
        this.download();
        break;
      case IndividualAccidentsScenario.formSubmitted:
        this.fillForms();
        break;
      default:
        console.log(this.requestInfo[0].currentStep);
    }
  }

  setButton(request: IndividualAccidentsRequest) {
    switch (request.currentStep) {
      case IndividualAccidentsScenario.paid:
        this.pageStatus = 'payment';
        this.buttonLabel = 'پرداخت حق بیمه';
        break;
      case IndividualAccidentsScenario.formSubmitted:
        this.pageStatus = 'formSubmitted';
        this.buttonLabel = 'تکمیل پرسشنامه';
        break;
      case IndividualAccidentsScenario.waitingForRelease:
        this.pageStatus = IndividualAccidentsScenario.waitingForRelease;
        this.buttonLabel = '';
        break;
      case IndividualAccidentsScenario.insuranceReleased:
        this.pageStatus = IndividualAccidentsScenario.insuranceReleased;
        this.buttonLabel = 'دانلود بیمه نامه';
        break;
    }
  }

  showPaymentPanel() {
    this.router.navigate([`/invoice/INDIVIDUAL_ACCIDENTS/${this.requestID}`]);
  }


  download() {
    this.service.downloadNewInsurance(this.requestInfo[0].id).subscribe((response: Response) => {
      if (response.success) {
        StaticMethods.goToLink(response.data.directLink);
      }
    });
  }

  hideFinance() {
    this.paymentMode = false;
  }


  private fillForms() {
    StaticMethods.fillForms(this.router, 'INDIVIDUAL_ACCIDENTS', this.requestInfo[0].id, this.icon);
  }


  private getDetails(requestID: number, cb: any) {
    console.log(requestID);
    this.service.getRequestInfo(requestID).subscribe((response: Response) => {
      console.log(response);
      if (response.success) {
        this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
        let scenario;
        switch (response.data.clientType) {
          case 'B2B':
            scenario = IndividualAccidentsScenario.B2BScenario;
            break;
          default:
            scenario = IndividualAccidentsScenario.generalScenario;
        }
        this.requestInfo[0] = new IndividualAccidentsRequest(response.data, scenario);
        this.setButton(this.requestInfo[0]);
        cb();
      }
    });
  }
}
